import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {
  AbstractControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { CouponService, ExcelService } from '@fitness-force/api';
import { Status } from '@fitness-force/enum';
import { AppErrors, ErrorMsgComponent } from '@fitness-force/errors';
import {
  OfferMaster,
  CouponByMasterId,
  GenerateCouponCodesRequest,
  CouponCodes,
  UpdateCouponLinkRequest,
} from '@fitness-force/models';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { STAFF_STATE } from 'apps/ff-frontend/src/app/state/app.state';
import { ToastMessageService } from '@fitness-force/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { ScrollPanelModule } from 'primeng/scrollpanel';

import { BehaviorSubject, Observable } from 'rxjs';
import { DataGridComponent,NoComponentComponent} from '@fitness-force/grid';
// import { DataGridComponent } from '../../data-grid/data-grid.component';
// import { NoComponentComponent } from '../../data-grid/empty-state/no-component/no-component.component';
import {  ActionsComponent} from '@fitness-force/grid-utility/action'
import { CouponCountEditComponent } from '../../data-grid/utility/coupon/coupon-count-edit/coupon-count-edit.component';
import { CouponNameEditComponent } from '../../data-grid/utility/coupon/coupon-name-edit/coupon-name-edit.component';
import { EntityStatusComponent } from '../../data-grid/utility/entity-status/entity-status.component';
import { InputNumberComponent } from '../../input-number/input-number.component';

@Component({
  selector: 'app-vanity-coupon',
  templateUrl: './vanity-coupon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    FormsModule,
    ReactiveFormsModule,
    ScrollPanelModule,
    ButtonModule,
    InputNumberModule,
    InputTextModule,
    DataGridComponent,
    ErrorMsgComponent,
    InputNumberComponent,
    TranslateModule
]
})
export class VanityCouponComponent implements OnInit {
  @Input() couponMaster: OfferMaster;
  @Input('visible') visible: boolean = false;
  @Output('closePopup') closePopup: EventEmitter<any> = new EventEmitter();

  coupons$ = new BehaviorSubject<CouponByMasterId[]>([]);
  formGroup: UntypedFormGroup;
  generateCouponsModal = new BehaviorSubject(false);
  couponArray: string[] = [];
  loadingBtn: boolean = false;
  columns: any = new BehaviorSubject([]);

  loading = new BehaviorSubject<boolean>(false);
  emptyStateComponent$ = new BehaviorSubject<any>(NoComponentComponent);
  couponCodeLinkBymasterId: CouponByMasterId;
  getAccessedStaffList$ = new BehaviorSubject<any[] | any>([]);

  constructor(
    private coupnService: CouponService,
    public formBuilder: UntypedFormBuilder,
    public translate: TranslateService,
    private toastMessageService: ToastMessageService, private excelService: ExcelService,
    private store: Store
  ) { }

  ngOnInit(): void {
    this.getCouponsByMasterId();
    this.GetStaffs();
  }

  getCouponsByMasterId() {
    this.loading.next(true);
    this.coupnService
      .getCouponsByMasterid(this.couponMaster.tenant_id, this.couponMaster.id)
      .subscribe({
        next: (response: any) => {
          let coupons = response.items as CouponByMasterId[];
          coupons.forEach(obj => {
            obj.status = obj.coupon_code_status;
            obj.remaining_count = obj.coupon_max_redepmtion_count - obj.coupon_current_redepmtion_count;
          });
          this.coupons$.next(coupons);
          this.columnTranslate();
          this.visible = true;
          this.loading.next(false);
        },
        error: (error: any) => {
          this.visible = false;
          this.loading.next(false);
        },
      });
  }

  columnTranslate() {
    this.translate
      .get([
        'ADMIN.COUPON.COUPON_NAME',
        'ADMIN.COUPON.NO_OF_TIMES_USED',
        'ADMIN.COUPON.REMAINING',
        'ADMIN.COUPON.COUPON_COUNT',
        'ADMIN.COMMON.STATUS'
      ])
      .subscribe((translations) => {
        this.setColumnTranslate(translations);
      });
  }
  setColumnTranslate(translations: any) {
    let column = {
      Name: translations['ADMIN.COUPON.COUPON_NAME'],
      Used: translations['ADMIN.COUPON.NO_OF_TIMES_USED'],
      Remaining: translations['ADMIN.COUPON.REMAINING'],
      Count: translations['ADMIN.COUPON.COUPON_COUNT'],
      Status: translations['ADMIN.COMMON.STATUS'],
    };

    this.columns.next([
      {
        title: column.Name,
        classes: 'py-2 white-space-nowrap relative font-bold text-primary capitalize',
        sortable: true,
        filterable: true,
        dataProperty: 'coupon_code',
        type: 'component',
        data: {
          name: CouponNameEditComponent,
          additionData: true,
          aData: { primary: true },
        },
      },
      {
        title: column.Used,
        classes: 'py-2 white-space-nowrap capitalize',
        sortable: true,
        filterable: true,
        dataProperty: 'coupon_current_redepmtion_count',
        type: 'default',
      },
      {
        title: column.Remaining,
        classes: 'py-2 white-space-nowrap capitalize',
        sortable: true,
        filterable: true,
        dataProperty: 'remaining_count',
        type: 'default',
      },
      {
        title: column.Count,
        classes: 'py-2 white-space-nowrap capitalize',
        sortable: true,
        filterable: true,
        dataProperty: 'coupon_max_redepmtion_count',
        type: 'component',
        data: {
          name: CouponCountEditComponent,
          additionData: true,
          aData: { primary: true },
        },
      },
      {
        title: column.Status,
        classes: 'py-2 white-space-nowrap capitalize',
        sortable: true,
        filterable: true,
        dataProperty: 'status',
        type: 'component',
        data: { name: EntityStatusComponent },
      },
      {
        title: '',
        classes: 'py-2 white-space-nowrap',
        dataProperty: 'actions',
        type: 'component',
        data: {
          name: ActionsComponent,
          additionData: true,
          aData: ['status'],
        },
      },
    ]);
  }

  openAddCoupon() {
    this.formGroup = this.formBuilder.group({
      max_redepmtion_count: new UntypedFormControl(null, [Validators.required]),
      coupon_name: new UntypedFormControl('', [Validators.required]),
      method: new UntypedFormControl('create')
    });
    this.generateCouponsModal.next(true);
  }


  formSubmit() {
    if (this.formGroup.valid) {
      this.loadingBtn = true;
      if (this.formGroup.controls.method.value.toLowerCase() == 'create') {
        this.GenerateMoreCoupons();
      }
      else {
        this.UpdateCouponCode();
      }

    } else {
      Object.keys(this.formGroup.controls).forEach((field) => {
        const control = this.formGroup.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
    }
  }

  GenerateMoreCoupons() {
    let payload = {} as GenerateCouponCodesRequest;
    payload.coupon_type = this.couponMaster.coupon_type.toString();
    payload.coupon_codes = [];
    let couponCodes: CouponCodes = {} as CouponCodes;
    couponCodes.coupon_code = this.formGroup.controls.coupon_name.value;
    couponCodes.max_redepmtion_count = this.formGroup.controls.max_redepmtion_count.value;
    payload.coupon_codes.push(couponCodes);
    this.coupnService.GenerateMoreCoupons(
      this.couponMaster.tenant_id,
      this.couponMaster.id,
      payload
    )
      .subscribe({
        next: (response: any) => {
          this.loadingBtn = false;
          this.generateCouponsModal.next(false);
          this.translate
            .get('ADMIN.COUPON.ERRORS.CRETE_MORE_COUPON')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.formGroup.reset();
          this.getCouponsByMasterId();
        },
        error: (error: AppErrors) => {
          this.loadingBtn = false;
          this.handleToastError(error);
        },
      });
  }

  closeAddCouponPopup() {
    this.formGroup.reset();
    this.generateCouponsModal.next(false);
  }

  CloseCouponPopup() {
    this.closePopup.emit(true);
  }

  handleToastError(error: any) {
    if (error.originalError.error.length > 0) {
      error.originalError.error.forEach((e: any) => {
        this.toastMessageService.showErrorMessage(e);
      });
    } else {
      this.toastMessageService.showErrorMessage(error);
    }
  }

  onActionEvent(event: any) {
    switch (event.action.toLowerCase()) {
      case 'edit':
        this.couponCodeLinkBymasterId = event.columnData as CouponByMasterId;
        this.formGroup = this.formBuilder.group({
          max_redepmtion_count: new UntypedFormControl(
            this.couponCodeLinkBymasterId.coupon_max_redepmtion_count,
            [Validators.required]
          ),
          coupon_name: new UntypedFormControl(this.couponCodeLinkBymasterId.coupon_code, [
            Validators.required,
          ]),
          method: new UntypedFormControl('update', [
            Validators.required,
          ]),
        });
        this.generateCouponsModal.next(true);
        break;
      case 'status':
        let couponLink = event.columnData as CouponByMasterId;
        this.MarkActiveInactiveCouponLink(
          couponLink,
          couponLink.coupon_code_status == Status.Active || couponLink.coupon_code_status.toString() == Status[Status.Active] ? false : true
        );
        break;
      case 'delete':
        break;
      case 'nameupdated':
        this.getCouponsByMasterId();
        break;
    }
  }

  MarkActiveInactiveCouponLink(
    couponCodeLink: CouponByMasterId,
    status: boolean
  ) {
    let service: Observable<any>;
    if (status) {
      service = this.coupnService.MarkCouponCodeLinkActive(
        couponCodeLink.tenant_id,
        couponCodeLink.offer_master_id,
        couponCodeLink.id
      );
    } else {
      service = this.coupnService.MarkCouponCodeLinkInActive(
        couponCodeLink.tenant_id,
        couponCodeLink.offer_master_id,
        couponCodeLink.id
      );
    }
    service.subscribe({
      next: (response: any) => {
        this.translate
          .get(
            status
              ? 'ADMIN.COUPON.ERRORS.MARK_AS_ACTIVE'
              : 'ADMIN.COUPON.ERRORS.MARK_AS_INACTIVE'
          )
          .subscribe((translation) => {
            this.toastMessageService.showSuccess(translation);
          });
        this.getCouponsByMasterId();
      },
      error: (error: any) => {
        this.handleToastError(error);
      },
    });
  }

  UpdateCouponCode() {
    let payload: UpdateCouponLinkRequest = {} as UpdateCouponLinkRequest;
    let coupon_code = {
      coupon_code: this.formGroup.controls.coupon_name.value,
      max_redepmtion_count: this.formGroup.controls.max_redepmtion_count.value,
    };
    payload.coupon_code = coupon_code;
    this.coupnService.UpdateCoupenMasterCouponLink(
      this.couponCodeLinkBymasterId.tenant_id,
      this.couponCodeLinkBymasterId.offer_master_id,
      this.couponCodeLinkBymasterId.id,
      payload
    )
      .subscribe({
        next: (res: any) => {
          this.generateCouponsModal.next(false);
          this.loadingBtn = false;
          this.translate.get('ADMIN.COUPON.ERRORS.COUPON_UPDATED')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.formGroup.reset();
          this.getCouponsByMasterId();
        },
        error: (error: any) => {
          this.loadingBtn = false;
          this.handleToastError(error);
        },
      });
  }

  async DownloadCSV() {
    let couponData: any = [];
    this.coupons$.getValue().forEach(o => {
      let couponCode = { CouponName: '', UsedCount: 0, TotalCount: 0, RemainingCount: 0, CreatedBy: '', CreatedDate: '' };
      couponCode.CouponName = o.coupon_code;
      couponCode.TotalCount = o.coupon_max_redepmtion_count;
      couponCode.UsedCount = o.coupon_current_redepmtion_count;
      couponCode.RemainingCount = o.remaining_count!;
      couponCode.CreatedBy = this.getStaffName(o.created_by);
      couponCode.CreatedDate = o.created_date.toString();
      couponData.push(couponCode);
    })
    this.excelService.exportAsExcelFile(couponData, 'vanity_coupon', 'csv')
  }

  GetStaffs() {
    this.store.select(STAFF_STATE).subscribe((data: any) => {
      if (data && data.staffList && data.staffList.length > 0) {
        this.getAccessedStaffList$.next(
          data.staffList.filter((o: any) => {
            return (
              String(o.status).toLowerCase() == 'active'
            );
          })
        );
      }
    });
  }

  getStaffName(staffId: number) {
    return this.getAccessedStaffList$.getValue().find((o: { id: number; }) => o.id == staffId).name;
  }

  get nameControl(): AbstractControl {
    return this.formGroup.controls.coupon_name;
  }
  get maxRedemptionControl(): AbstractControl {
    return this.formGroup.controls.max_redepmtion_count;
  }
}
